import { Button, ButtonGroup, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import CustomSnackbar from '../snackbar/snackbar';
import Loader from '../loader/loader';
import { downloadFile, uploadFile } from '../../api.service/user.service';
import ModalWrapper from '../modal/modal';
import FileUpload from './fileUpload/fileUpload';
import ImgPdfViewer from '../../pages/imageAndPdfViewer/imgPdfViewer';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import '../fileUploaderDownloader/fileUploaderDownloader.css'

interface FileDetails {
    file: File | undefined,
    fileType: boolean
}

const BASE_URL = process.env.REACT_APP_BASE_URL;

interface FileUploaderDownloaderProps {
    onView?: (params: any) => void
}

const FileUploaderDownloader = (props: FileUploaderDownloaderProps) => {
    const [fileDetails, setFileDetails] = useState<FileDetails>({
        file: undefined,
        fileType: false
    })
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [openImageModal, setOpenImageModal] = useState<boolean>(false)
    const [imageUrl, setImageUrl] = useState<any>('')
    const [loader, setLoader] = useState<boolean>(false)
    const [showCopyClickBoard, setShowCopyClickBoard] = useState<boolean>(false)
    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        backgroundColor: ''
    })
    const [fileDms, setFileDms] = useState<string>('');
    console.log(openSnackbar, "Snackbar")

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const handleOpenImageModal = () => {
        setOpenImageModal(true)
    }

    const handleCloseImageModal = () => {
        setOpenImageModal(false)
    }

    console.log(fileDetails, "File Detailssssssssssss")

    const handleFileUpload = () => {
        handleOpenModal()
    };

    const download = () => {
        setLoader(true)
        downloadFile(fileDms).then((result: any) => {
            console.log(result, "Result on download")
            const linkSource = window.URL.createObjectURL(result.data);
            setImageUrl(linkSource)
            handleOpenImageModal()

            setOpenSnackbar({
                open: false,
                message: '',
                backgroundColor: 'green'
            });
            setLoader(false)
        }).catch((error) => {
            if (error) {
                setOpenSnackbar({
                    open: true,
                    message: `Fail to download file, can't view`,
                    backgroundColor: 'red'
                });
                setLoader(false)
            }
        })
    }

    const handleCloseSnackbar = () => {
        setOpenSnackbar({
            open: false,
            message: '',
            backgroundColor: ''
        })
    }

    const handlFileDetails = (fileDetails: any) => {
        console.log(fileDetails, "File details")
        if (fileDetails) {
            setFileDetails(fileDetails)

            setLoader(true)
            uploadFile(fileDetails).then((result: any) => {
                if (result.data) {
                    setFileDms(result.data.dmscode)
                    setShowCopyClickBoard(true)
                    setOpenSnackbar({
                        open: true,
                        message: 'File Uploaded',
                        backgroundColor: 'green'
                    });
                    handleCloseModal()
                }
                setLoader(false)
            }).catch(error => {
                if (error) {
                    setOpenSnackbar({
                        open: true,
                        message: 'File Upload Failed...',
                        backgroundColor: 'red'
                    });
                    setLoader(false)
                }
            })
        }
    }

    const viewByDMS = (isPdf: boolean) => {
        let dms = prompt("Please enter dms code");
        if (dms != null) {
            setFileDetails({
                fileType: isPdf,
                file: undefined
            })
            downloadFile(dms).then((result: any) => {
                console.log(result, "Result on download")
                const linkSource = window.URL.createObjectURL(result.data);
                setImageUrl(linkSource)
                handleOpenImageModal()
                setOpenSnackbar({
                    open: false,
                    message: '',
                    backgroundColor: 'green'
                });
                setLoader(false)
            }).catch((error) => {
                if (error) {
                    setOpenSnackbar({
                        open: true,
                        message: `Failed to download file, can't view`,
                        backgroundColor: 'red'
                    });
                    setLoader(false)
                }
            })
        }
    }

    const copyDms = async () => {
        const textToCopy = fileDms;
        const success = await copyText(textToCopy);

        if (success) {
            setOpenSnackbar({
                open: true,
                message: `${fileDetails.fileType ? 'Pdf' : 'Image'} Dms code copied successfully!`,
                backgroundColor: 'green'
            });
        } else {
            setOpenSnackbar({
                open: true,
                message: `Failed to copy ${fileDetails.fileType ? 'Pdf' : 'Image'} Dms code.`,
                backgroundColor: 'red'
            });
        }
    }

    const copyText = async (text: string | null | undefined): Promise<boolean> => {
        if (text === '' || text === null || text === undefined) return false;
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            return false;
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px' }}>

            <div>
                <label htmlFor="file-input">
                    <Button variant="outlined" component="span" onClick={handleFileUpload}>
                        Upload File
                    </Button>
                </label>
            </div>
            {/* <div>
                <Button variant='contained' onClick={download}>View File</Button>
            </div> */}
            {showCopyClickBoard ? <Tooltip title={fileDetails.fileType ? 'Copy Pdf Dms Code' : 'Copy Image Dms Code'} placement='top'>
                <div className='copy-click-board-container' onClick={copyDms} >

                    {/* <ContentCopyIcon sx={{ fontSize: '25px' }} /> */}
                    <span style={{
                        width: '100%',
                        display: 'block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '100%',
                        paddingLeft: '2px'
                    }}>{fileDms}</span>

                </div></Tooltip> : null}
            <div>
                <Button variant='contained' onClick={() => viewByDMS(false)}>View Image By DMS</Button>
            </div>
            <div>
                <Button variant='contained' onClick={() => viewByDMS(true)}>View Pdf By DMS</Button>
            </div>
            <CustomSnackbar data={openSnackbar.open ? openSnackbar : false} onClose={handleCloseSnackbar} />
            <ModalWrapper open={openModal} close={handleOpenModal} children={<FileUpload onClose={handleCloseModal} handlFileDetails={handlFileDetails} />} />
            <ModalWrapper open={openImageModal} close={handleOpenImageModal} width={fileDetails.fileType ? { xs: 0.9, sm: 0.8, md: 600 } : undefined} children={<ImgPdfViewer onClose={handleCloseImageModal} data={imageUrl} fileType={fileDetails.fileType} />} />
            <Loader loader={loader} />
        </div>
    )
}

export default FileUploaderDownloader
